import L from 'mapbox-gl';
export class Map {
    constructor() {
        L.accessToken = 'pk.eyJ1Ijoia2V2eW94IiwiYSI6ImNrZ3Q1cTM2MzA3anEyc3FyN2p3ZmV4MG4ifQ.RKqSPqqE_uiqlOtedtWllQ';
        const map = new L.Map({
            container: 'map', // container ID
            style: 'mapbox://styles/kevyox/cle8av15n008001qmtvrxxffx', // style URL
            center: [2.228550, 50.405860], // starting position [lng, lat]
            zoom: 12, // starting zoom
        });

        new L.Marker({
            color: "#566250",
        })
            .setLngLat([2.228550, 50.405860])
            .addTo(map);

    }
}
